import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

interface Props {
  children: React.ReactNode;
}

function SummaryLine({ children }: Props) {
  const classes = useStyles();

  return <div className={classes.root}>{children}</div>;
}

const useStyles = makeStyles(theme => ({
  root: { display: 'flex', alignItems: 'center' },
}));

export default SummaryLine;
